import React, { Component } from "react";
import UserActivityListItem from "./UserActivityListItem";
import InfiniteScroll from "react-infinite-scroller";

class UserActivityList extends Component {
    render() {
        const {
            profile,
            activities,
            getNextActivities,
            loading,
            moreActivities
        } = this.props;
        console.log("activities ", activities);
        return (
            <div>
                {activities && activities.length !== 0 && (
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={getNextActivities}
                        hasMore={!loading && moreActivities}
                        initialLoad={false}
                    >
                        {activities &&
                            activities.map(activity => (
                                <UserActivityListItem
                                    key={activity.id}
                                    profile={profile}
                                    activity={activity}
                                    attendess={activity.attendess}
                                />
                            ))}
                    </InfiniteScroll>
                )}
            </div>
        );
    }
}

export default UserActivityList;
